import * as React from 'react';
import { TBoardId } from '../../../../../../../types/types';
import { PreviewHOC } from '../../../../preview/Preview/hocs/PreviewHOC/PreviewHOC';

export const getCardPreviewBody = (
    boardId: TBoardId
): JSX.Element => {
    return (<PreviewHOC boardId={boardId} />)
};
